import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { IdentityService } from '../services/identity.service';
import { from, Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { LogHelper } from '../helpers/log.helper';
import { PkceHelper } from '../helpers/pkce.helper';
import { CanActivate } from '../interfaces/can-activate.interface';
import { OptionsService } from '../services/options.service';

@Injectable({
	providedIn: 'root'
})
export class IdentityAuthGuard implements CanActivate {
	constructor(private readonly identityService: IdentityService, private readonly os: OptionsService) {}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
		/**
		 * check if the user is authenticated;
		 * if an error happened - redirect to IDMS url to re-login;
		 * return true on success and false on error
		 */
		return this.identityService.authenticate().pipe(
			catchError(error => {
				LogHelper.error(error);

				/**
				 * no session → re-login. PKCE: stash a code_verifier and redirect to IDMS
				 * with the S256 code_challenge so the code IDMS mints is bound to this
				 * client (verified back at POST /redeem-code).
				 */
				return from(PkceHelper.buildLoginRedirectUrl(this.os.options, state.url)).pipe(
					map(url => {
						window.location.href = url;

						return null;
					})
				);
			}),
			map(accessToken => !!accessToken)
		);
	}
}
